exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-drawer__body{overflow-y:scroll}.close{z-index:9;font-size:25px;color:#aaa;position:fixed;right:0;top:0;padding:10px 20px 0 0;cursor:pointer}.drawer-alert{position:fixed;top:20px;z-index:2004}.drawer-alert .el-alert{min-width:380px;height:48px}.drawer-alert .el-alert__closebtn{line-height:28px;font-size:14px}", ""]);

// exports
